import { createAppTableSaga, createAppTableStore, createPersist } from 'components/AppTable/store';
import apiRoutes from 'config/apiRoute';

export const projectSlice = createAppTableStore({
  name: 'tableProjects' as const,
  url: apiRoutes.PROJECTS_LITE,
  initialState: {
    params: {
      filters: {
        'projects.status': [{ value: 'active' }],
      },
    },
    updateUrl: apiRoutes.PROJECTS,
  },
});

export const projectsSaga = createAppTableSaga(projectSlice);

export const projectsReducer = createPersist(projectSlice);
